import React, { useState } from "react"
import { Forward, Check, Link } from "lucide-react"
import { motion, AnimatePresence } from "framer-motion"
import { useTranslation } from "react-i18next"

const ChatHeader = ({ chat, isMobile, onBack, onToggleSidebar }) => {
  const { t } = useTranslation()
  const { bundle_id } = chat
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    if (copied) return
    const originUrl = new URL(window.location.origin)
    const url = `${originUrl}book/bundle/edit/${bundle_id}?chat_id=${bundle_id}`
    try {
      await navigator.clipboard.writeText(url.toString())
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error("Ошибка копирования:", err)
    }
  }

  return (
    <div className="flex items-center justify-between px-4 py-3 bg-gradient-to-r from-slate-50 to-blue-50/30 border-b border-slate-200 flex-shrink-0">
      <div className="flex items-center gap-3 flex-1 min-w-0">
        {isMobile && (
          <button
            onClick={onBack}
            className="p-2 text-slate-600 hover:bg-white/50 rounded-lg transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
        )}
        <div className="flex-1 min-w-0">
          <h2 className="font-semibold text-slate-900 text-base truncate">
            <a
              href={`/book/bundle/edit/${bundle_id}?chat_id=${bundle_id}`}
            >{`${t("request_form.notifications_request")} ${bundle_id}`}</a>
          </h2>
        </div>
      </div>

      <div className="flex items-center gap-1 flex-shrink-0">
        <div className="relative">
          {/* Button */}
          <motion.button
            onClick={handleCopy}
            whileTap={{ scale: 0.88 }}
            className="p-2.5 hover:bg-white/70 rounded-full transition-colors relative overflow-hidden"
          >
            <AnimatePresence mode="wait">
              {copied ? (
                <motion.span
                  key="check"
                  initial={{ scale: 0, rotate: -45, opacity: 0 }}
                  animate={{ scale: 1, rotate: 0, opacity: 1 }}
                  exit={{ scale: 0, opacity: 0 }}
                  transition={{ type: "spring", stiffness: 500, damping: 25 }}
                >
                  <Check className="w-5 h-5 text-green-500" />
                </motion.span>
              ) : (
                <motion.span
                  key="forward"
                  initial={{ scale: 0, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  exit={{ scale: 0, opacity: 0 }}
                  transition={{ duration: 0.15 }}
                >
                  <Link className="w-5 h-5 text-text-secondary" />
                </motion.span>
              )}
            </AnimatePresence>
          </motion.button>
        </div>
      </div>
    </div>
  )
}

export default ChatHeader
